export default {
  "fr": {
    "upsell": {
      "contact_us": "Intéressé? Contactez-nous",
      "decisions_partners": {
        "guidance": "Les partenaires de décision peuvent créer et/ou gérer des propositions s'ils y sont autorisés. <br>Vous pouvez en savoir plus sur les partenaires de décision <a class='is-underlined' href='/help/content/partners/ partners.html#decision-partners' target='_blank'>ici</a>",
        "intercom": "Bonjour Ziggu ! Je suis intéressé par la fonctionnalité Decision Partners. Pouvez-vous fournir plus d'informations? Cordialement, %{name}"
      },
      "decisions_reminders": {
        "guidance": "Les rappels vous permettent d'informer automatiquement les clients qu'il y a des propositions en attente d'une décision.<br>Vous pouvez en savoir plus sur les rappels <a class='is-underlined' href='/help/content/decisions/decisions.html?#step-3-optional-settings' target='_blank'>ici</a>",
        "intercom": "Bonjour Ziggu! Je suis intéressé par la fonctionnalité Rappels. Pouvez-vous fournir plus d'informations? Cordialement, %{name}"
      },
      "integration_aircall": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec Aircall. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Aircall",
          "title_sub": "Transférer des contacts vers Aircall ou enregistrer des appels dans Ziggu"
        }
      },
      "integration_archisnapper": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec Archisnapper. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Archisnapper",
          "title_sub": "Poussez vos listes de contrôle Archisnapper vers Ziggu"
        }
      },
      "integration_astena": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec Astena. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Astena",
          "title_sub": "Poussez vos versements, factures et autres données financières Ziggu"
        }
      },
      "integration_bouwsoft": {
        "intercom": "Bonjour Ziggu! Je suis intéressé par l'integration avec Bouwsoft. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Bouwsoft",
          "title_sub": "Poussez vos contacts, unités et versements Bouwsoft vers Ziggu"
        }
      },
      "integration_bricsys": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec Bricsys. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Bricsys",
          "title_sub": "Transférez vos documents Bricsys vers Ziggu"
        }
      },
      "integration_exact_online": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec Exact Online. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Exact Online",
          "title_sub": "Transférez vos versements, factures et autres données financières Exact Online vers Ziggu"
        }
      },
      "integration_hubspot": {
        "intercom": "Bonjour Ziggu! Je suis intéressé par l'integration avec Hubspot. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Hubspot",
          "title_sub": "Poussez vos contacts, unités et documents Hubspot vers Ziggu"
        }
      },
      "integration_kpd": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec KPD. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "KPD",
          "title_sub": "Transférez vos versements, factures et autres données financières vers Ziggu"
        }
      },
      "integration_letsbuild": {
        "intercom": "Bonjour Ziggu! Je suis intéressé par le module Project Experience. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Letsbuild",
          "title_sub": "Poussez vos points Letsbuild vers Ziggu"
        }
      },
      "integration_navision": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec Microsoft Dynamics Navision. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Microsoft Dynamics Navision",
          "title_sub": "Transférez vos contacts, versements, factures et autres données financières vers Ziggu"
        }
      },
      "integration_power_bi": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec PowerBI. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "PowerBI",
          "title_sub": "Transférez vos statistiques PowerBI et autres données vers Ziggu"
        }
      },
      "integration_realpad": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec Realpad. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Realpad",
          "title_sub": "Poussez vos contacts vers Ziggu"
        }
      },
      "integration_salesforce": {
        "intercom": "Bonjour Ziggu! Je suis intéressé par l'integration avec Salesforce. Pouvez-vous fournir plus d'informations ? Cordialement, %{name}",
        "marketplace": {
          "title": "Salesforce",
          "title_sub": "Poussez vos contacts, unités, documents et versements Salesforce vers Ziggu"
        }
      },
      "integration_sap": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec SAP. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "SAP",
          "title_sub": "Transférez vos contacts, versements, factures et autres données financières vers Ziggu"
        }
      },
      "integration_sharepoint": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec Sharepoint. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Sharepoint",
          "title_sub": "Transférez vos documents vers Ziggu"
        }
      },
      "integration_teamleader": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec Teamleader. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Teamleader",
          "title_sub": "Transférez vos contacts, versements, factures et autres données financières vers Ziggu"
        }
      },
      "integration_yuki": {
        "intercom": "Bonjour Ziggu ! Je suis intéressé par l'intégration avec Yuki. Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Yuki",
          "title_sub": "Transférez vos versements, factures et autres données financières vers Ziggu"
        }
      },
      "integration_zoho": {
        "intercom": "Bonjour Ziggu! Je suis intéressé par l'integration avec Zoho. Pouvez-vous fournir plus d'informations ? Cordialement, %{name}",
        "marketplace": {
          "title": "Zoho",
          "title_sub": "Poussez vos contacts, unités, documents et versements Zoho vers Ziggu"
        }
      },
      "marketplace": {
        "category": {
          "feature": "Fonctionnalité",
          "integration": "Intégration"
        }
      },
      "not_included": "💡 Intéressé par cette fonctionnalité 💡",
      "project_email_forwarding": {
        "cta": "Transfert d'e-mails {project_name}",
        "description": "Permettez à tous les membres de votre équipe de transférer des e-mails directement à vos projets Ziggu.",
        "intercom": "Bonjour Ziggu ! Je suis intéressé par la fonctionnalité . Pouvez-vous fournir plus d'informations? Cordialement, %{name}",
        "marketplace": {
          "title": "Project email forwarding",
          "title_sub": "Transférez les e-mails directement à vos projets Ziggu."
        },
        "title": "Nouveau! Transfert d'e-mails pour des projets",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Vous pouvez me contacter pour cela!",
        "cta": "Améliorer l'image de marque de votre projet?",
        "description": "URL de projet personnalisée et écran de connexion <br/> Environnement de projet dédié lorsque vous êtes connecté <br/> E-mails de marque de projet <br/> Facilite la collaboration avec d'autres promoteurs immobiliers sur le même projet",
        "intercom": "Bonjour Ziggu ! Je suis intéressé par le module Project Experience. Pouvez-vous fournir plus d'informations ? Cordialement, %{name}",
        "marketplace": {
          "title": "Project experience",
          "title_sub": "Améliorez l'image de marque de votre projet avec une URL et un environnement de projet personnalisés"
        },
        "title": "Faites en sorte que vos clients se sentent chez eux avec la toute nouvelle <br>Project Experience !",
        "youtube_id": "f26cNo2rwWE"
      },
      "proposal_choice_lists": {
        "guidance": "Les listes de choix vous permettent de laisser les clients faire des choix dans des propositions.<br>Vous pouvez en savoir plus sur les listes de choix <a class='is-underlined' href='/help/content/decisions/decisions.html#choice-list' target='_blank'>ici</a>",
        "intercom": "Bonjour Ziggu! Je suis intéressé par la fonctionnalité Listes de choix. Pouvez-vous fournir plus d'informations? Cordialement, %{name}"
      },
      "signatures": {
        "cta_text": "Besoin de signatures pour vos documents ? Contactez-nous",
        "guidance": "Les signatures vous permettent de permettre aux clients de signer numériquement des documents importants.<br>Vous pouvez en savoir plus sur les rappels <a class='is-underlined' href='/help/content/decisions/decisions.html#electronic-signature' target='_blank'>ici</a>",
        "intercom": "Bonjour Ziggu! Je suis intéressé par la fonctionnalité Signatures. Pouvez-vous fournir plus d'informations ? Cordialement, %{name}"
      }
    }
  }
}